import { StateToken } from '@ngxs/store';
import {
  BaseData,
  Department,
  GatewayTransactionResult,
  GiftCard,
  Ticket,
  PosPaymentRequest,
  NormalizedTicket,
  FreedomPayResponse
} from 'src/app/models';

export interface LastGatewayTransaction {
  ticket: Ticket | NormalizedTicket;
  paymentRequest: PosPaymentRequest;
  result?: GatewayTransactionResult;
  stripe_payment_secret?: string;
  stripe_pk_test?: string;
  stripe_pk_production?: string;
  stripe_account_id?: string;
}

export interface LastTerminalTransaction {
  ticket: Ticket | NormalizedTicket;
  paymentRequest: PosPaymentRequest;
  freedomPayResponse: FreedomPayResponse;
}

export interface PaymentStateModel {
  departments: Department[];
  businessLines: BaseData[];
  selectedGiftCard: GiftCard;
  lastGatewayTransaction: LastGatewayTransaction;
  lastTerminalTransaction?: LastTerminalTransaction;
}

export const PAYMENT_STATE_TOKEN = new StateToken<PaymentStateModel>('payment');
